var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about flexContainerColumn",attrs:{"id":"about"}},[_c('BandDescription'),_c('Quotations')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }